// 降落航线
export default {
    landingRoute: 'Посадочный маршрут',
    HDP: 'Защита от перепада высот',
    generate: 'генерировать',
    read: 'Читать',
    clear: 'ясно',
}